import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CREATE_LIST_KEY } from "./createList.constants";

export const useCreateListLabel = (overrideKey?: string) => {
  const { t } = useTranslation();
  return useCallback(
    (key: string, options?: Record<string, unknown>) => {
      const listKey = `${CREATE_LIST_KEY}.${key}`;
      return overrideKey ? t([`${overrideKey}.${key}`, listKey], options) : t(listKey, options);
    },
    [t, overrideKey]
  );
};
